import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import {
    GlobalProxy,
    createGlobalProxy,
    ContextProxy,
    createContextProxy,
} from '@patsnap/hiro-event-proxy';
import { GetHiroBasic } from '@analytics/shared/apis/get-hiro-basic-api.interface';
import { HiroBasicApiServiceImpl } from '@analytics/shared/apis/hiro-basic-api-service';
import { HiroEntryService } from '@patsnap/hiro-event-proxy';
import { HiroEntryServiceImpl } from './service/hiro-entry.service';

export const hiroEntryModule = (bind: interfaces.Bind) => {
    bind(GlobalProxy).toConstantValue(createGlobalProxy());
    bind(ContextProxy).toConstantValue(createContextProxy());
    bind(HiroEntryService).to(HiroEntryServiceImpl);

    // api
    bind(GetHiroBasic).to(HiroBasicApiServiceImpl);
};
